/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Whether the module is discoverable by every tenant (VISIBLE) or only by the tenants holding an entitled survey under it, or under its vendor module when that vendor module is itself protected (PROTECTED).
 */
export enum SurveyModuleVisibility {
    VISIBLE = 'VISIBLE',
    PROTECTED = 'PROTECTED',
}
